import { Box } from "@mui/material";
import { deletedClientClientGroupMenu } from "data/constants";
import useQueryParams from "hooks/useQueryParams";
import { useNavigate } from "react-router-dom";
import { StyledProfileNav, StyledProfileNavItem } from "views/clients/styles";
import DeletedClients from "./deleted-clients";
import DeletedClientGroups from "./deleted-client-groups";

function DeletedClientClientGroup() {
  const navigate = useNavigate();
  const { queryParams } = useQueryParams();
  const active = queryParams.tab || "Clients";

  return (
    <>
      <Box sx={{ position: "sticky", top: 65, bgcolor: "white", zIndex: 2 }}>
        <StyledProfileNav>
          {deletedClientClientGroupMenu.map((item, index) => (
            <StyledProfileNavItem
              key={index}
              onClick={() => navigate(`?tab=${item.title}`)}
              active={active === item.title ? 1 : 0}
            >
              {item.title}
            </StyledProfileNavItem>
          ))}
        </StyledProfileNav>
      </Box>
      <Box px={1} py={1} pb={0} mb={0}>
        {active === "Clients" && <DeletedClients />}
        {active === "Clients Group" && <DeletedClientGroups />}
      </Box>
    </>
  );
}

export default DeletedClientClientGroup;
